import React from 'react';
import {FormattedMessage} from "react-intl";

import Grid from "@mui/material/Grid";

import HeaderContainer from "components/List/components/HeaderContainer";

function Header(props) {
    return (
        <HeaderContainer>
            <Grid
                item
                container
                xs={4}
                columnSpacing={2}
            >
                <Grid item>
                    <FormattedMessage id={'shippingMethods.header.icon'} />
                </Grid>
                <Grid item>
                    <FormattedMessage id={'shippingMethods.header.name'} />
                </Grid>
            </Grid>
            <Grid
                item
                container
                xs={4}
                columnSpacing={2}
                justifyContent={'space-between'}
            >
                <Grid item>
                    <FormattedMessage id={'shippingMethods.header.type'} />
                </Grid>
                <Grid item>
                    <FormattedMessage id={'shippingMethods.header.sylius-code'} />
                </Grid>
            </Grid>
            <Grid
                item
                container
                xs={4}
                columnSpacing={2}
                justifyContent={"flex-end"}
                flexWrap={"nowrap"}
            >
                <Grid item sx={{ width: '60px' }}>
                    <FormattedMessage id={'shippingMethods.header.active'} />
                </Grid>
                <Grid item sx={{ width: '80px' }}>
                    <FormattedMessage id={'list.header.actions'} />
                </Grid>
            </Grid>
        </HeaderContainer>
    );
}

export default Header;
